var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { dataArrayChunk, REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../lib";
import { ApiSmpPageSubscription } from "./subscription";
export class ApiSmpPage {
}
_a = ApiSmpPage;
ApiSmpPage.listById = (req) => __awaiter(void 0, void 0, void 0, function* () {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    let response = {
        next: null,
        previous: null,
        results: [],
    };
    if (((_b = req === null || req === void 0 ? void 0 : req.query) === null || _b === void 0 ? void 0 : _b.medium_external_id__in) &&
        !req.query.medium_external_id__in.length) {
        return response;
    }
    if (((_c = req === null || req === void 0 ? void 0 : req.query) === null || _c === void 0 ? void 0 : _c.id__in) && !req.query.id__in.length) {
        return response;
    }
    if (!((_d = req === null || req === void 0 ? void 0 : req.query) === null || _d === void 0 ? void 0 : _d.medium_external_id__in) && !((_e = req === null || req === void 0 ? void 0 : req.query) === null || _e === void 0 ? void 0 : _e.id__in)) {
        return response;
    }
    if (((_f = req === null || req === void 0 ? void 0 : req.query) === null || _f === void 0 ? void 0 : _f.medium_external_id__in) &&
        ((_g = req === null || req === void 0 ? void 0 : req.query) === null || _g === void 0 ? void 0 : _g.medium_external_id__in.length) > 100) {
        const chunks = dataArrayChunk(req.query.medium_external_id__in, 100);
        for (let chunk of chunks) {
            const responseChunk = yield apiRequest({
                endpoint: `${REACT_APP__URL_SMP_API}/page/v1/by-id/`,
                method: "GET",
                next: req === null || req === void 0 ? void 0 : req.next,
                query: Object.assign(Object.assign({}, req.query), { medium_external_id__in: chunk }),
            });
            response = Object.assign(Object.assign({}, responseChunk), { results: [...response.results, ...responseChunk.results] });
        }
    }
    else if (((_h = req === null || req === void 0 ? void 0 : req.query) === null || _h === void 0 ? void 0 : _h.id__in) && ((_j = req === null || req === void 0 ? void 0 : req.query) === null || _j === void 0 ? void 0 : _j.id__in.length) > 100) {
        const chunks = dataArrayChunk(req.query.id__in, 100);
        for (let chunk of chunks) {
            const responseChunk = yield apiRequest({
                endpoint: `${REACT_APP__URL_SMP_API}/page/v1/by-id/`,
                method: "GET",
                next: req === null || req === void 0 ? void 0 : req.next,
                query: Object.assign(Object.assign({}, req.query), { id__in: chunk }),
            });
            response = Object.assign(Object.assign({}, responseChunk), { results: [...response.results, ...responseChunk.results] });
        }
    }
    else {
        response = yield apiRequest({
            endpoint: `${REACT_APP__URL_SMP_API}/page/v1/by-id/`,
            method: "GET",
            next: req === null || req === void 0 ? void 0 : req.next,
            query: req === null || req === void 0 ? void 0 : req.query,
        });
    }
    return response;
});
ApiSmpPage.retrieveByExternalId = (req) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API +
        `/page/v1/by-external-id/${req.path.medium__external_id}`,
    method: "GET",
});
ApiSmpPage.retrieveById = (req) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API + `/page/v1/by-id/${req.path.id}`,
    method: "GET",
});
ApiSmpPage.Subscription = ApiSmpPageSubscription;
//# sourceMappingURL=page.js.map